import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { MDBView } from "mdbreact";
import { Search } from "../../../../../components/searchables";
import {
  FILTERBYCATEGORY,
  SetFILTER,
  ResetFILTER,
} from "../../../../../services/redux/slices/assets/providers";
import Directory from "./directory";
const Header = () => {
  const { token, activePlatform } = useSelector(({ auth }) => auth),
    { filtered, collections } = useSelector(({ providers }) => providers),
    [directoryKey, setDirectoryKey] = useState(null),
    dispatch = useDispatch();

  //initial values
  useEffect(() => {
    if (token) {
      dispatch(
        FILTERBYCATEGORY({
          token,
          keys: {
            clients: activePlatform?.branchId,
            category: "supplier",
            stats: 1,
          },
        }),
      );
    }
  }, [token, activePlatform, dispatch]);
  // registered suppliers are searched first before registering a new one
  const handleAdd = (key) => setDirectoryKey(key || "");
  const handleFiltered = (items) => dispatch(SetFILTER(items));

  return (
    <>
      <MDBView
        cascade
        className="gradient-card-header custom-header blue-gradient narrower py-2 mx-4 mb-3 d-flex justify-content-between align-items-center"
      >
        <div className="d-flex justify-items-center" style={{ width: "20rem" }}>
          <span className="white-text mx-3 text-nowrap mt-0">
            {filtered.length} Branch Suppliers
          </span>
        </div>
        <div>
          <div className="text-right d-flex items-center">
            <Search
              collections={collections}
              setFiltered={handleFiltered}
              handleAdd={handleAdd}
              reset={() => dispatch(ResetFILTER())}
            />
          </div>
        </div>
      </MDBView>
      <Directory
        show={directoryKey !== null}
        initialKey={directoryKey || ""}
        toggle={() => setDirectoryKey(null)}
      />
    </>
  );
};

export default Header;
